import { createSlice } from "@reduxjs/toolkit";
import { AuroraV2Abilities } from "./aurora-V2.types";
import { fetchAuroraV2Abilities } from "./aurora-V2.actions";

export interface AuroraV2State {
  abilities: AuroraV2Abilities;
  externalDesignToolLink: string;
}
const initialState: AuroraV2State = {
  abilities: {
    canViewExternalDesign: false,
    canViewExternalProposal: false,
  },
  externalDesignToolLink: "",
};

const auroraV2Slice = createSlice({
  name: "auroraV2",
  initialState,
  reducers: {
    fetchAuroraAbilities(state) {},
    syncAuroraV2() {},
  },
  extraReducers: builder => {
    builder
      .addCase(fetchAuroraV2Abilities.pending, (state, action) => {})
      .addCase(fetchAuroraV2Abilities.fulfilled, (state, action) => {
        state.abilities = action.payload.abilities;
        state.externalDesignToolLink = action.payload.externalDesignToolLink;
      })
      .addCase(fetchAuroraV2Abilities.rejected, (state, action: any) => {});
  },
});

export const { fetchAuroraAbilities, syncAuroraV2 } = auroraV2Slice.actions;

export default auroraV2Slice;
